import { Overlay } from "ol";

export default class SisOverlay {
	constructor(selector, map, positioning = "bottom-center", offset = [0, 0], className = "") {
		// 오버레이 생성
		this.overlay = new Overlay({
			id: selector.substring(1),
			element: document.querySelector(selector),
			offset: offset,
			positioning: positioning,
			className: `sisOverlay ${className}`,
		});

		map.addOverlay(this.overlay);

		return this.overlay;
	}
}
